// AUTO-GENERATED by scripts/generate-fingerprint.mjs
// DO NOT EDIT MANUALLY - This file is regenerated on every build

/**
 * Contracts Version and Fingerprint
 * 
 * The fingerprint is a SHA256 hash of all schema files in v0_18_0
 * and is used to detect schema drift and ensure SSOT compliance.
 */

export const CONTRACTS_VERSION = "0.19.1";
export const CONTRACTS_FINGERPRINT = "0.19.1:fff38a6da619fbc648368b655694138563c73124d49105f725c5d23959bca7ac";

// Helper function to validate fingerprint at runtime
export const validateFingerprint = (expectedFingerprint: string): boolean => {
  return CONTRACTS_FINGERPRINT === expectedFingerprint;
};

// Helper function to get version info
export const getVersionInfo = () => ({
  version: CONTRACTS_VERSION,
  fingerprint: CONTRACTS_FINGERPRINT,
  generatedAt: "2025-10-15T12:27:45.132Z",
});
